import React from "react";
import { Select, Checkbox } from "antd";

const Option = Select.Option;

class EditFilter extends React.Component {
  render() {
    const { options } = this.props;
    return (
      <div className="filter__options">
        <div className="filter__head">
          <div className="filter__row">
            <Checkbox defaultChecked={options.active}>{options.title}</Checkbox>
          </div>
        </div>
        <div className={"filter__body " + (options.active ? "" : "disabled")}>
          <div className="filter__row">
            <div className="filter__cell">
              <Select
                className="filter__select"
                defaultValue="1"
                placeholder=""
              >
                <Option value="1">Keep only</Option>
              </Select>
              <div className="filter__text">variants which are:</div>
            </div>
          </div>
          <div className="filter__row">
            <Checkbox>Associated with gain of function</Checkbox>
          </div>
          <div className="filter__label label">
            To control specific gain of function types, use the predicted
            deleterious filter
          </div>
          <div className="filter__row filter__row_grid">
            {options.items.map((x, i) => (
              <div className="filter__cell" key={i}>
                <Checkbox defaultChecked={x.state}>{x.title}</Checkbox>
              </div>
            ))}
          </div>
          {options.additional && (
            <div>
              <div className="filter__row">
                <div className="filter__text">
                  The genotypes selected above occur in at least
                </div>
              </div>
              <div className="filter__row" style={{ marginBottom: 8 }}>
                <div className="filter__cell">
                  <Select
                    className="filter__select"
                    defaultValue="1"
                    placeholder=""
                  >
                    <Option value="1">1</Option>
                  </Select>
                  <div className="filter__text">variants which are:</div>
                </div>
              </div>
              <div className="filter__row" style={{ margin: 0 }}>
                <div className="filter__cell">
                  <Select
                    className="filter__select"
                    defaultValue="1"
                    placeholder=""
                  >
                    <Option value="1">gene level</Option>
                  </Select>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default EditFilter;
